<div class="authorization-confirm" *ngIf="sended">
    <h1 class="authorization-confirm-title">
        ¡Muchas gracias!
    </h1>
    <span class="authorization-confirm-description">
        {{ dictum === 'aprobacion' ? 'La garantía fue aprobada, estaremos en contacto con usted a la brevedad.' : 'La garantía fue rechazada, estaremos en contacto con usted a la brevedad.' }}
    </span>
    <img [src]="dictum === 'aprobacion' ? '/assets/images/scoring-result/approved/approved.png' : '/assets/images/scoring-result/rejected/rejected.png'" alt="" class="approved-image">
</div>
